var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7348 5.21719C13.8414 5.13242 14 5.21172 14 5.3457V10.9375C14 11.6621 13.4121 12.25 12.6875 12.25H1.3125C0.587891 12.25 0 11.6621 0 10.9375V5.34844C0 5.21172 0.155859 5.13516 0.265234 5.21992C0.877734 5.6957 1.68984 6.3 4.47891 8.32617C5.05586 8.74727 6.0293 9.6332 7 9.62773C7.97617 9.63594 8.96875 8.73086 9.52383 8.32617C12.3129 6.3 13.1223 5.69297 13.7348 5.21719ZM7 8.75C7.63438 8.76094 8.54766 7.95156 9.00703 7.61797C12.6355 4.98477 12.9117 4.75508 13.7484 4.09883C13.907 3.97578 14 3.78437 14 3.58203V3.0625C14 2.33789 13.4121 1.75 12.6875 1.75H1.3125C0.587891 1.75 0 2.33789 0 3.0625V3.58203C0 3.78437 0.0929687 3.97305 0.251563 4.09883C1.08828 4.75234 1.36445 4.98477 4.99297 7.61797C5.45234 7.95156 6.36562 8.76094 7 8.75Z",
    fill: "#EBE9E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledEnvelope);
export default __webpack_public_path__ + "static/media/filled-envelope.46607747475cf6d3e1b3ed4370c63a02.svg";
export { ForwardRef as ReactComponent };